module.exports = __webpack_public_path__ + "static/media/sem_gerenciar_documento.16e6d3bf.png";